import { render } from "./Step3.vue?vue&type=template&id=c479f3b4&scoped=true"
import script from "./Step3.vue?vue&type=script&lang=js"
export * from "./Step3.vue?vue&type=script&lang=js"

import "./Step3.vue?vue&type=style&index=0&id=c479f3b4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c479f3b4"]])

export default __exports__